// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersUnit_filters-unit__cFf9\\+ {
  max-width: 300px;
  width: 100%;
}
.FiltersUnit_filters-unit__cFf9\\+ .FiltersUnit_keyword-type-filter__aXE-c {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.FiltersUnit_filters-unit__cFf9\\+ .FiltersUnit_keyword-type-filter__aXE-c .FiltersUnit_keyword-type-filter--title__nYcEI {
  font-size: 13px;
}
.FiltersUnit_filters-unit__cFf9\\+ .FiltersUnit_keyword-type-filter__aXE-c .FiltersUnit_keyword-type-filter--tabs__VPd-V {
  background-color: #fff;
  border-radius: 8px;
  min-height: 0;
  border: 1px solid var(--explore-color);
}
.FiltersUnit_filters-unit__cFf9\\+ .FiltersUnit_keyword-type-filter__aXE-c .FiltersUnit_keyword-type-filter--tabs--indicator__XMp\\+6 {
  height: 100%;
  background-color: var(--explore-color);
}
.FiltersUnit_filters-unit__cFf9\\+ .FiltersUnit_keyword-type-filter__aXE-c .FiltersUnit_keyword-type-filter--tabs--item__-DaXy {
  z-index: 1;
  text-transform: initial;
  font-size: 11px;
  min-width: 0;
  min-height: 0;
  padding: 6px 8px;
}
.FiltersUnit_filters-unit__cFf9\\+ .FiltersUnit_keyword-type-filter__aXE-c .FiltersUnit_keyword-type-filter--tabs--item--selected__L30CO {
  color: white;
}

@media only screen and (max-width: 1200px) {
  .FiltersUnit_filters-unit__cFf9\\+ {
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/UnitList/Components/FiltersUnit/FiltersUnit.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;AACF;AACE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;AAEM;EACE,eAAA;AAAR;AAGM;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sCAAA;AADR;AAGQ;EACE,YAAA;EACA,sCAAA;AADV;AAIQ;EACE,UAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAFV;AAIU;EACE,YAAA;AAFZ;;AAUA;EACE;IACE,eAAA;EAPF;AACF","sourcesContent":[".filters-unit {\n  max-width: 300px;\n  width: 100%;\n\n  .keyword-type-filter {\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    .keyword-type-filter {\n      &--title {\n        font-size: 13px;\n      }\n\n      &--tabs {\n        background-color: #fff;\n        border-radius: 8px;\n        min-height: 0;\n        border: 1px solid var(--explore-color);\n\n        &--indicator {\n          height: 100%;\n          background-color: var(--explore-color);\n        }\n\n        &--item {\n          z-index: 1;\n          text-transform: initial;\n          font-size: 11px;\n          min-width: 0;\n          min-height: 0;\n          padding: 6px 8px;\n\n          &--selected {\n            color: white;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 1200px) {\n  .filters-unit {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters-unit": `FiltersUnit_filters-unit__cFf9+`,
	"keyword-type-filter": `FiltersUnit_keyword-type-filter__aXE-c`,
	"keyword-type-filter--title": `FiltersUnit_keyword-type-filter--title__nYcEI`,
	"keyword-type-filter--tabs": `FiltersUnit_keyword-type-filter--tabs__VPd-V`,
	"keyword-type-filter--tabs--indicator": `FiltersUnit_keyword-type-filter--tabs--indicator__XMp+6`,
	"keyword-type-filter--tabs--item": `FiltersUnit_keyword-type-filter--tabs--item__-DaXy`,
	"keyword-type-filter--tabs--item--selected": `FiltersUnit_keyword-type-filter--tabs--item--selected__L30CO`
};
export default ___CSS_LOADER_EXPORT___;
